import { createEmbedEmotionCache } from '@embed/createEmbedEmotionCache';
import { floatingButtonRender } from '@embed/floatingButtonRender';
import fwnInit from '@src/embeds/utils/fwnInit';
import { WidgetTypesEnum } from '../embed/widgetTypes';
import { FWNElement } from './bases/FWNElement';
fwnInit(window);
class ChannelButtonElement extends FWNElement {
    constructor() {
        super(...arguments);
        this.__version = process.env.RELEASE_VERSION;
    }
    render() {
        const attrs = Object.fromEntries(this.getAttributeNames().map((name) => [name, this.getAttribute(name)]));
        this.shadowRoot &&
            floatingButtonRender(Object.assign(Object.assign({}, attrs), { type: WidgetTypesEnum.CHANNEL_BUTTON, target: this.shadowRoot }), createEmbedEmotionCache({
                container: this.shadowRoot,
            }));
    }
}
if (!customElements.get('fw-channel-button')) {
    customElements.define('fw-channel-button', ChannelButtonElement);
}
